export default "__VITE_ASSET__de478676__"